import { gql } from '@apollo/client/core';

export const addMemberUser = gql`
  mutation ($where: MemberToOrganizationInput!, $data: MemberDataInOrganization!) {
    admin {
      addMemberToOrganization(where: $where, data: $data) {
        code
        adviseMessage {
          code
          description
        }
      }
    }
  }
`;
